<template>
  <Card class="mb-6">
    <CardHeader>
      <CardTitle>Description</CardTitle>
    </CardHeader>
    <CardContent>
      <p>{{ description }}</p>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

defineProps<{
  description: string
}>()
</script>
